<script setup lang="ts">
/**
 * AIRA as a companion: Glow + AIRA + two AI stars.
 * `welcome` — Hero 560×380 (mobile: fills the free height); `result` — Hero 240 with a
 * smaller AIRA 140×202 (Style 15 Result). `aiMark=false` hides the stars (Measurements).
 */
import { FairIcon } from '@/ui/primitives/FairIcon'
import airaImage from '@/assets/quiz/aira-quiz.webp'

interface FairQuizHeroProps {
  size?: 'welcome' | 'result'
  aiMark?: boolean
}

withDefaults(defineProps<FairQuizHeroProps>(), {
  size: 'welcome',
  aiMark: true,
})
</script>

<template>
  <div
    class="fair-quiz-hero"
    :class="`fair-quiz-hero--${size}`"
    aria-hidden="true"
  >
    <div class="fair-quiz-hero__glow" />
    <img
      class="fair-quiz-hero__aira"
      :src="airaImage"
      alt=""
    >
    <template v-if="aiMark">
      <FairIcon
        class="fair-quiz-hero__star fair-quiz-hero__star--large"
        name="ai"
        color="var(--fair-rd-ai-star)"
        :size="size === 'welcome' ? 20 : 16"
      />
      <FairIcon
        class="fair-quiz-hero__star fair-quiz-hero__star--small"
        name="ai"
        color="var(--fair-rd-ai-star-soft)"
        :size="size === 'welcome' ? 16 : 14"
      />
    </template>
  </div>
</template>
